<template>
  <div class="flex flex-col">
    <div class="flex flex-row justify-between gap-4">
      <Breadcrumbs/>
    </div>
    <template v-if="stores">
      <div class="flex flex-col items-center py-4">
        <div class="flex flex-col gap-4 max-w-4xl min-w-full md:min-w-[600px] p-4 md:p-8 rounded-2xl bg-slate-800/50">
          <div class="flex flex-row">
            <button v-for="s in stores" @click="selectStore(s)"
                    :class="[
                      selectedStore?.store === s.store
                      ? 'dark:text-white text-slate-100 bg-slate-600 dark:bg-primary-700'
                      : 'text-slate-700 bg-slate-300 dark:bg-slate-700 dark:text-slate-300',
                    ]"
                    class="text-xs font-medium last:mb-0 capitalize ring-0 foucs:ring-0 focus:outline-none px-3 md:px-6 py-2 transition duration-150 rounded-none first:rounded-l-2xl last:rounded-r-2xl"
            >{{ s.store }}
            </button>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex flex-row gap-2 items-center text-xs">
              <span class="text-[4px] text-slate-900 dark:text-slate-300">⬤</span>
              <p class="whitespace-nowrap text-xs text-slate-900 dark:text-slate-300">Commission Fee:</p>
              <div v-if="selectedStore?.commissionFee" class="w-full text-slate-900 dark:text-slate-300">
                {{ selectedStore?.commissionFee ? (selectedStore.commissionFee * 100) + ' %' : '&nbsp' }}
              </div>
              <div v-else class="w-full text-slate-900 dark:text-slate-300">
                Store not selected
              </div>
            </div>
            <div class="flex flex-row gap-2 items-start text-xs">
              <span class="text-[4px] text-slate-900 dark:text-slate-300">⬤</span>
              <p class="whitespace-nowrap text-xs text-slate-900 dark:text-slate-300">Withdrawal Fee:</p>
              <div v-if="selectedStore?.withdrawalFee" class="w-full text-slate-900 dark:text-slate-300">
                {{ selectedStore?.withdrawalFee ? (selectedStore.withdrawalFee * 100) + ' %' : '&nbsp' }}
              </div>
              <div v-else class="w-full text-slate-900 dark:text-slate-300">
                Store not selected
              </div>
            </div>
          </div>
          <div class="h-0.5 bg-slate-700 w-full"></div>
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-0.5 text-xs">
              <label for="currencyToman" class="text-slate-900 dark:text-slate-300">
                {{ selectedStore?.currency }} / TOMAN
              </label>
              <div
                  class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                <input id="currencyToman"
                       type="text"
                       v-model="form.currencyToman"
                       @input="onInput('currencyToman')"
                       class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
              </div>
            </div>
            <div class="flex flex-col gap-0.5 text-xs">
              <label for="profitPercent" class="text-slate-900 dark:text-slate-300">Profit %</label>
              <div
                  class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                <input id="profitPercent"
                       type="text"
                       v-model="form.profitPercent"
                       @input="onInput('profitPercent')"
                       class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <div class="flex flex-row items-center gap-4">
                <span class="text-white text-base">Selling</span>
                <div class="h-0.5 bg-slate-700/50 w-full"></div>
              </div>
              <div class="flex flex-col gap-0.5 text-xs">
                <label for="sellPrice" class="text-slate-900 dark:text-slate-300">
                  Sell Price ({{ selectedStore?.currency }})
                </label>
                <div
                    class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                  <input id="sellPrice"
                         type="text"
                         v-model="form.sellPrice"
                         @input="onInput('sellPrice')"
                         class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <div class="flex flex-row items-center gap-4">
                <span class="text-white text-base">Buying</span>
                <div class="h-0.5 bg-slate-700/50 w-full"></div>
              </div>
              <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-0.5 text-xs">
                  <label for="buyPriceG2G" class="text-slate-900 dark:text-slate-300">
                    Buy Price (G2G {{ selectedStore?.currency }})
                  </label>
                  <div
                      class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                    <input id="buyPriceG2G"
                           type="text"
                           v-model="form.buyPriceG2G"
                           @input="onInput('buyPriceG2G')"
                           class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
                  </div>
                </div>
                <div class="flex flex-col gap-0.5 text-xs">
                  <label for="buyPriceEldorado" class="text-slate-900 dark:text-slate-300">
                    Buy Price (Eldorado {{ selectedStore?.currency }})
                    {{ eldoradoRealBuyPrice ? `(Real Cost: ${eldoradoRealBuyPrice})` : '' }}
                  </label>
                  <div
                      class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                    <input id="buyPriceEldorado"
                           type="text"
                           v-model="form.buyPriceEldorado"
                           @input="onInput('buyPriceEldorado')"
                           class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
                  </div>
                </div>
                <div class="flex flex-col gap-0.5 text-xs">
                  <label for="buyPriceCurrency" class="text-slate-900 dark:text-slate-300">
                    Buy Price ({{ selectedStore?.currency }})
                  </label>
                  <div
                      class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                    <input id="buyPriceCurrency"
                           type="text"
                           v-model="form.buyPriceCurrency"
                           @input="onInput('buyPriceCurrency')"
                           class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
                  </div>
                </div>
                <div class="flex flex-col gap-0.5 text-xs">
                  <label for="buyPriceToman" class="text-slate-900 dark:text-slate-300">Buy Price (Toman)</label>
                  <div
                      class="flex flex-row gap-2 items-center w-full dark:bg-slate-900 border border-slate-700 pr-3 rounded-md h-[32px]">
                    <input id="buyPriceToman"
                           type="text"
                           v-model="form.buyPriceToman"
                           @input="onInput('buyPriceToman')"
                           class="bg-transparent w-full pl-3 block focus:outline-none text-slate-900 dark:text-slate-200 h-full rounded-md autofill-fix dark:[--shadow-color:#0f172a] [--text-color:#0f172a] dark:[--text-color:rgb(203,213,225)] dark:[--caret-color:rgb(203,213,225)]">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="flex items-center justify-center h-60">
      <Icon icon="eos-icons:bubble-loading" class="size-12"/>
    </div>
  </div>
</template>

<script setup>
import {Icon} from "@iconify/vue";
import Breadcrumbs from "@/components/Breadcrumbs/index.vue";
import {ref, computed, watch, reactive} from "vue";
import {useConfigStore} from "@/stores/config.js";

const configStore = useConfigStore();
const storeOrder = [
  'DealHub USD',
  'Incepto USD',
  'Eldorado Currency',
  'Eldorado WoW Gold'
]
const stores = computed(() =>
    storeOrder
        .map(name => configStore.getStores?.find(s => s.store === name))
        .filter(Boolean)
)
const eldoradoWithdrawalFee = computed(() => configStore.getStores?.find(s => s.store === 'Eldorado').withdrawalFee)
const selectedStore = ref(null);
const isLoading = ref(false);
const lastEditedField = ref('');
const eldoradoRealBuyPrice = ref(null)

const form = reactive({
  store: null,
  currencyToman: '',
  profitPercent: 0.00,
  sellPrice: '',
  buyPriceG2G: '',
  buyPriceEldorado: '',
  buyPriceCurrency: '',
  buyPriceToman: ''
});

const profitPercent = computed(() => form.profitPercent / 100);

// Helper function to format numbers: round close to integer, limit to 8 decimals, remove trailing zeros
function formatNumber(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return value;

  // Round if close to integer (within 1e-8)
  const rounded = Math.round(num);
  if (Math.abs(num - rounded) < 1e-8) {
    return rounded.toString();
  }

  // Format to 8 decimals and remove trailing zeros
  const fixed = num.toFixed(8);
  const [integerPart, decimalPart] = fixed.split('.');
  if (decimalPart && decimalPart.match(/^0+$/)) {
    return integerPart;
  }
  return fixed.replace(/\.?0+$/, '');
}

function selectStore(store) {
  selectedStore.value = store;
}

function onInput(field) {
  // Validate input to allow only numbers and decimals
  const value = form[field];
  if (value && !/^\d*\.?\d*$/.test(value)) {
    form[field] = value.slice(0, -1) || '';
    return;
  }

  // Only set lastEditedField for specific fields
  if (['sellPrice', 'buyPriceG2G', 'buyPriceEldorado', 'buyPriceCurrency', 'buyPriceToman'].includes(field)) {
    lastEditedField.value = field;
  }

  // Handle empty fields
  if (field === 'currencyToman' && !form.currencyToman) {
    if (lastEditedField.value !== 'buyPriceG2G') form.buyPriceG2G = '';
    if (lastEditedField.value !== 'buyPriceEldorado') form.buyPriceEldorado = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    return;
  }

  if (field === 'profitPercent' && !form.profitPercent) {
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    if (lastEditedField.value !== 'buyPriceG2G') form.buyPriceG2G = '';
    if (lastEditedField.value !== 'buyPriceEldorado') form.buyPriceEldorado = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    return;
  }

  if (field === 'sellPrice' && !form.sellPrice) {
    if (lastEditedField.value !== 'buyPriceG2G') form.buyPriceG2G = '';
    if (lastEditedField.value !== 'buyPriceEldorado') form.buyPriceEldorado = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    return;
  }

  if (field === 'buyPriceG2G' && !form.buyPriceG2G) {
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    return;
  }

  if (field === 'buyPriceEldorado' && !form.buyPriceEldorado) {
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    return;
  }

  if (field === 'buyPriceCurrency' && !form.buyPriceCurrency) {
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    if (lastEditedField.value !== 'buyPriceG2G') form.buyPriceG2G = '';
    if (lastEditedField.value !== 'buyPriceEldorado') form.buyPriceEldorado = '';
    if (lastEditedField.value !== 'buyPriceToman') form.buyPriceToman = '';
    return;
  }

  if (field === 'buyPriceToman' && !form.buyPriceToman) {
    if (lastEditedField.value !== 'sellPrice') form.sellPrice = '';
    if (lastEditedField.value !== 'buyPriceG2G') form.buyPriceG2G = '';
    if (lastEditedField.value !== 'buyPriceEldorado') form.buyPriceEldorado = '';
    if (lastEditedField.value !== 'buyPriceCurrency') form.buyPriceCurrency = '';
    return;
  }

  // Perform calculations if required fields are present
  if (!form.currencyToman || (!form.profitPercent && form.profitPercent !== 0) || !selectedStore.value) return;

  const commissionFee = selectedStore.value.commissionFee;
  const withdrawalFee = selectedStore.value.withdrawalFee;

  if (field === 'sellPrice' && form.sellPrice) {
    calc_buyPriceG2G(commissionFee);
    calc_buyPriceEldorado(commissionFee, withdrawalFee);
    calc_buyPriceCurrency(commissionFee, withdrawalFee);
    calc_buyPriceToman();
  } else if (field === 'buyPriceG2G' && form.buyPriceG2G) {
    form.sellPrice = formatNumber(form.buyPriceG2G / ((1 - commissionFee) * (1 - profitPercent.value)));
    calc_buyPriceEldorado(commissionFee, withdrawalFee);
    calc_buyPriceCurrency(commissionFee, withdrawalFee);
    calc_buyPriceToman();
  } else if (field === 'buyPriceEldorado' && form.buyPriceEldorado) {
    form.sellPrice = formatNumber((form.buyPriceEldorado * (1 - eldoradoWithdrawalFee.value)) / ((1 - commissionFee) * (1 - withdrawalFee) - profitPercent.value));
    calc_buyPriceG2G(commissionFee);
    calc_buyPriceCurrency(commissionFee, withdrawalFee);
    calc_buyPriceToman();
  } else if (field === 'buyPriceCurrency' && form.buyPriceCurrency) {
    form.sellPrice = formatNumber(form.buyPriceCurrency / ((1 - commissionFee) * (1 - withdrawalFee) * (1 - profitPercent.value)));
    calc_buyPriceG2G(commissionFee);
    calc_buyPriceEldorado(commissionFee, withdrawalFee);
    calc_buyPriceToman();
  } else if (field === 'buyPriceToman' && form.buyPriceToman) {
    calc_buyPriceCurrencyFromToman();
    form.sellPrice = formatNumber(form.buyPriceCurrency / ((1 - commissionFee) * (1 - withdrawalFee) * (1 - profitPercent.value)));
    calc_buyPriceG2G(commissionFee);
    calc_buyPriceEldorado(commissionFee, withdrawalFee);
  } else if (field === 'currencyToman' || field === 'profitPercent') {
    if (form.sellPrice && lastEditedField.value === 'sellPrice') {
      calc_buyPriceG2G(commissionFee);
      calc_buyPriceEldorado(commissionFee, withdrawalFee);
      calc_buyPriceCurrency(commissionFee, withdrawalFee);
      calc_buyPriceToman();
    } else if (form.buyPriceG2G && lastEditedField.value === 'buyPriceG2G') {
      form.sellPrice = formatNumber(form.buyPriceG2G / ((1 - commissionFee) * (1 - profitPercent.value)));
      calc_buyPriceEldorado(commissionFee, withdrawalFee);
      calc_buyPriceCurrency(commissionFee, withdrawalFee);
      calc_buyPriceToman();
    } else if (form.buyPriceEldorado && lastEditedField.value === 'buyPriceEldorado') {
      form.sellPrice = formatNumber((form.buyPriceEldorado * (1 - eldoradoWithdrawalFee.value)) / ((1 - commissionFee) * (1 - withdrawalFee) - profitPercent.value));
      calc_buyPriceG2G(commissionFee);
      calc_buyPriceCurrency(commissionFee, withdrawalFee);
      calc_buyPriceToman();
    } else if (form.buyPriceCurrency && lastEditedField.value === 'buyPriceCurrency') {
      form.sellPrice = formatNumber(form.buyPriceCurrency / ((1 - commissionFee) * (1 - withdrawalFee) * (1 - profitPercent.value)));
      calc_buyPriceG2G(commissionFee);
      calc_buyPriceEldorado(commissionFee, withdrawalFee);
      calc_buyPriceToman();
    } else if (form.buyPriceToman && lastEditedField.value === 'buyPriceToman') {
      calc_buyPriceCurrencyFromToman();
      form.sellPrice = formatNumber(form.buyPriceCurrency / ((1 - commissionFee) * (1 - withdrawalFee) * (1 - profitPercent.value)));
      calc_buyPriceG2G(commissionFee);
      calc_buyPriceEldorado(commissionFee, withdrawalFee);
    }
  }

  calc_eldoradoRealBuyPrice();
}

const calc_buyPriceG2G = (commissionFee) => {
  form.buyPriceG2G = formatNumber(form.sellPrice * (1 - commissionFee) * (1 - profitPercent.value));
}

const calc_buyPriceEldorado = (commissionFee, withdrawalFee) => {
  form.buyPriceEldorado = formatNumber((form.sellPrice * ((1 - commissionFee) * (1 - withdrawalFee) - profitPercent.value)) / (1 - eldoradoWithdrawalFee.value));
}

const calc_buyPriceCurrency = (commissionFee, withdrawalFee) => {
  form.buyPriceCurrency = formatNumber(form.sellPrice * ((1 - commissionFee) * (1 - withdrawalFee) - profitPercent.value));
}

const calc_buyPriceCurrencyFromToman = () => {
  form.buyPriceCurrency = formatNumber(form.buyPriceToman / form.currencyToman);
}

const calc_buyPriceToman = () => {
  form.buyPriceToman = formatNumber(form.buyPriceCurrency * form.currencyToman);
}

const calc_eldoradoRealBuyPrice = () => {
  eldoradoRealBuyPrice.value = form.buyPriceEldorado * (1.01 - eldoradoWithdrawalFee.value)
}

watch(stores, (newVal) => {
  if (newVal && newVal.length > 0) {
    selectedStore.value = newVal[0];
  }
}, {immediate: true});

watch(selectedStore, () => {
  onInput(lastEditedField.value);
});
</script>

<style scoped>
</style>